import React from "react";
import vector1 from "../assets/Vector.png";
import trip from "../assets/Trip-amico (1) 1.png";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const BoardingScreen1 = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden", // Ensures no part of the image goes outside
      }}
    >
      {/* images container */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          width: "90%",
        }}
      >
        {/* First image (vector1) */}
        <Box
          component="img"
          src={vector1}
          alt="vector-img"
          sx={{
            position: "absolute",
            zIndex: 1, // Make sure vector1 is behind trip
            width: "100%", // Adjust the width as needed
            top: 0,
            left: 0,
            objectFit: "cover", // Ensures image fits without overflow
          }}
        />
        {/* Second image (trip) */}
        <Box
          component="img"
          src={trip}
          alt="trip-img"
          sx={{
            position: "relative",
            zIndex: 2, // Make sure trip is in front of vector1
            width: "80%", // Adjust the width as needed
            top: "40%",
          }}
        />
      </Box>

      {/* Text below the images */}
      <Box
        sx={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          width: "100%",
          maxWidth: "300px",
          gap: 2,
          flexDirection: "column",
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "start" }}>
          {t("BoardingScreen1Title")}
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "start" }}>
          {t("BoardingScreen1Subtitle")}
        </Typography>
      </Box>
    </Box>
  );
};

export default BoardingScreen1;
